import { BaseClient } from '../BaseClient';
import {
  EmailTask,
  EmailTaskList,
  EmailTaskRecipient,
  EmailTaskRecipientList,
  EmailTaskScheduleType,
  EmailTaskScheduleTypeList,
  EmailTaskTriggerRecipientResult,
  EmailTaskTriggerResult,
} from '../compiled-protos/email_task';
import { EmailTaskServiceClient } from '../compiled-protos/email_task.client';

class EmailTaskClient extends BaseClient {
  self: EmailTaskServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new EmailTaskServiceClient(this.transport);
  }

  public async Create(req: EmailTask) {
    return await this.self.create(req, this.getMetaData()).response;
  }

  public async Get(req: EmailTask) {
    return await this.self.get(req, this.getMetaDataWithoutCache()).response;
  }

  public async BatchGet(req: EmailTask) {
    return await this.self.batchGet(req, this.getMetaDataWithoutCache()).response;
  }

  public async Update(req: EmailTask) {
    return await this.self.update(req, this.getMetaData()).response;
  }

  public async Delete(req: EmailTask) {
    return await this.self.delete(req, this.getMetaData()).response;
  }

  public async CreateRecipient(req: EmailTaskRecipient) {
    return await this.self.createRecipient(req, this.getMetaData()).response;
  }

  public async GetRecipient(req: EmailTaskRecipient) {
    return await this.self.getRecipient(req, this.getMetaDataWithoutCache()).response;
  }

  public async BatchGetRecipient(req: EmailTaskRecipient) {
    return await this.self.batchGetRecipient(req, this.getMetaDataWithoutCache()).response;
  }

  public async UpdateRecipient(req: EmailTaskRecipient) {
    return await this.self.updateRecipient(req, this.getMetaData()).response;
  }

  public async DeleteRecipient(req: EmailTaskRecipient) {
    return await this.self.deleteRecipient(req, this.getMetaData()).response;
  }

  public async BatchGetScheduleType(req: EmailTaskScheduleType) {
    return await this.self.batchGetScheduleType(req, this.getMetaDataWithoutCache()).response;
  }

  public async Trigger(req: EmailTask) {
    return await this.self.trigger(req, this.getMetaDataWithoutCache()).response;
  }
}

export {
  EmailTask,
  EmailTaskClient,
  EmailTaskList,
  EmailTaskRecipient,
  EmailTaskRecipientList,
  EmailTaskScheduleType,
  EmailTaskScheduleTypeList,
  EmailTaskTriggerRecipientResult,
  EmailTaskTriggerResult,
};
